<template>
    <div id="DigitalClinicsMeetingRoom">
        <div v-if="loading" class="d-flex align-items-center h-100">
            <Loader class="py-5 px-5 my-5"></Loader>
        </div>
        <div v-else-if="isWaiting">
          <WaitingRoom :booking="booking" :coach="serviceProvider"></WaitingRoom>
        </div>
        <div v-else-if="error_message">
          <Error :message="error_message" />
        </div>
        <div v-if="jwt" class="mx-4 animate__animated animate__fadeIn">
          <VideoRoomContainer :key="jwt" :booking="jwt" :info="booking" :coach="serviceProvider" class="animate__animated animate__fadeIn"/>
        </div>
        <Footer v-if="booking"></Footer>
    </div>
</template>
<script>

import Loader from "@/components/Loader";
import WaitingRoom from '@/components/Video/WaitingRoom.vue'
import VideoRoomContainer from '@/components/Video/VideoRoomContainer.vue'
import Footer from '@/components/Footer.vue'
import Error from '@/components/Video/Error.vue'

export default {
    components: {
      Error,
      Footer,
        Loader,
        WaitingRoom,
        VideoRoomContainer
    },
    name: "MainVideoWrapper",
    data() {
        return {
            loading: true,
            timeoutOver: false,
            booking: null,
            serviceProvider: null,
            jwt: null,
            isWaiting: true,
            loopIntervalId: null,
            error_message: null
        };
    },
    mounted() {
      this.$root.$on('requestToJoin', () => {
        this.requestToJoin()
      })
      this.$root.$emit('requestToJoin')
    },
    methods: {
        async init(token){
          const response = await this.sendRequest({
            path: `api/u/direct-video?token=${token}`
          })
          if (response.success === true){
            this.booking = response.booking
            this.serviceProvider = response.service_provider
            this.isWaiting = response.is_waiting;
            //room not created, i.e. waiting for coach to join
            if (!this.isWaiting){
              clearInterval(this.loopIntervalId)
              this.jwt = response.room.token
            }
          }else{
            this.isWaiting = false
            this.error_message = response.err
            clearInterval(this.loopIntervalId)
          }
          this.loading = false
        },
        requestToJoin(){
          this.loopIntervalId = setInterval(()=>{
            this.init(this.$route.params.token)
          },5000)
        }
    },
    computed: {
        envString() {
            console.log(process.env.NODE_ENV)
            return process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'staging';
        }
    },

};
</script>
<style lang="less">
#digital_clinics_modal___BV_modal_outer_ {
    z-index: 1000000 !important;
    * {
        scrollbar-width: thin;
        scrollbar-color: #aaa;
    }

    /* Chrome, Edge, and Safari */
    *::-webkit-scrollbar {
        width: 8px;
    }

    *::-webkit-scrollbar-track {
        background: rbga(0,0,0,0);
        margin: 10px
    }

    *::-webkit-scrollbar-thumb {
        background-color: #aaa;
        border-radius: 10px;
        border: 5px none #ffffff;
        opacity: 0;
    }
    .hidden-link{
        opacity: 0;
        cursor: pointer;
    }
}

#DigitalClinicsMeetingRoom {
    max-height: 93vh;
    overflow-y: auto;
    overflow-x: hidden;
}
</style>